export const movies = [
  {
    id: 'mv-1',
    title: '海上列车',
    genre: '剧情 / 冒险',
    year: 2025,
    duration: '132 分钟',
    rating: '8.6',
    tags: ['冒险', '剧情'],
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20adventure%20film%20poster%20art%2C%20vintage%20train%20crossing%20a%20sea%20bridge%20at%20warm%20golden%20sunset%2C%20dramatic%20amber%20and%20orange%20sky%2C%20epic%20journey%20mood%2C%20no%20text%2C%20high%20detail%20editorial%20texture&width=600&height=800&seq=cth-mov-01&orientation=portrait',
    note: '一趟横跨大海的列车，串起陌生人各自未说出口的心事。',
  },
  {
    id: 'mv-2',
    title: '尘世微光',
    genre: '剧情 / 家庭',
    year: 2024,
    duration: '118 分钟',
    rating: '9.0',
    tags: ['剧情', '家庭'],
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20film%20poster%20art%2C%20warm%20lit%20kitchen%20window%20at%20dusk%20with%20soft%20golden%20light%2C%20cozy%20intimate%20atmosphere%2C%20amber%20and%20brown%20tones%2C%20no%20text%2C%20delicate%20editorial%20style&width=600&height=800&seq=cth-mov-02&orientation=portrait',
    note: '一个普通家庭的四季流转，平静里全是力量。',
  },
  {
    id: 'mv-3',
    title: '暗涌',
    genre: '犯罪 / 悬疑',
    year: 2025,
    duration: '126 分钟',
    rating: '8.3',
    tags: ['犯罪', '悬疑'],
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20film%20poster%20art%2C%20dark%20alley%20with%20a%20single%20warm%20amber%20street%20lamp%2C%20long%20dramatic%20shadows%2C%20tense%20mysterious%20mood%2C%20crimson%20accents%2C%20no%20text%2C%20high%20contrast%20texture&width=600&height=800&seq=cth-mov-03&orientation=portrait',
    note: '一宗看似普通的失踪案，水面之下暗流远比想象复杂。',
  },
  {
    id: 'mv-4',
    title: '星尘信笺',
    genre: '科幻 / 爱情',
    year: 2024,
    duration: '140 分钟',
    rating: '8.1',
    tags: ['科幻', '爱情'],
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20romance%20film%20poster%20art%2C%20two%20silhouettes%20under%20a%20vast%20amber%20starfield%2C%20warm%20orange%20nebula%20glow%2C%20tender%20distant%20mood%2C%20no%20text%2C%20high%20detail%20editorial%20texture&width=600&height=800&seq=cth-mov-04&orientation=portrait',
    note: '相隔光年的两封信，把浪漫与孤独放在同一个宇宙里。',
  },
  {
    id: 'mv-5',
    title: '旧城拾光',
    genre: '文艺 / 剧情',
    year: 2023,
    duration: '108 分钟',
    rating: '8.4',
    tags: ['文艺', '剧情'],
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20art%20film%20poster%20art%2C%20quiet%20old%20town%20street%20in%20warm%20morning%20light%2C%20faded%20amber%20and%20cream%20tones%2C%20nostalgic%20literary%20mood%2C%20no%20text%2C%20soft%20textured%20editorial%20style&width=600&height=800&seq=cth-mov-05&orientation=portrait',
    note: '一位摄影师的返乡之旅，用镜头收藏正在消失的旧城。',
  },
  {
    id: 'mv-6',
    title: '疾风骑士',
    genre: '动作 / 体育',
    year: 2025,
    duration: '122 分钟',
    rating: '7.9',
    tags: ['动作', '体育'],
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20action%20sports%20film%20poster%20art%2C%20cyclist%20sprinting%20through%20warm%20dusty%20mountain%20road%2C%20dynamic%20motion%20blur%2C%20amber%20and%20crimson%20sunlight%2C%20energetic%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=cth-mov-06&orientation=portrait',
    note: '一支草根车队冲击职业赛场，热血但不失真实。',
  },
];